import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { AppService } from '../app.service';
import * as CryptoJS from 'crypto-js';

export interface Login {
  api_key: string;
  authority: number;
  message: string;
  status: string;
  user_id: number;
}

@Injectable()
export class LoginService {
  constructor(private http: HttpClient, private appService: AppService) {}

  postLogin(company_code, username, password): Observable<Login> {
    return this.http.post<Login>(this.appService.base_url + 'admin/login', {
      company_code: company_code,
      username: username,
      password: CryptoJS.HmacSHA256(password, 'nsi!@#$').toString(),
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.service.ts